import PropTypes from 'prop-types';
import './AhaWidget.css';
import { Modal, Button } from 'react-bootstrap';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';

const AhaWidget = ({isOpen, onClose }) => {
  const handleButtonClick = () => {
    window.open('https://castlelearning.ideas.aha.io/', '_blank');
    onClose();
  };

  return (
    <>
      <Modal
        className="custom-modal right"
        show={isOpen}
        onHide={onClose}
        dialogClassName="modal-right"
      >
        <Modal.Header className='popUp-header'>
          <FontAwesomeIcon
            className="modal-header-icon ms-2 text-white"
            size="2x"
            icon={faXmark}
            onClick={onClose}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="text-center p-4">
            <p>Help us build the Castle! Explore and vote on new ideas here!</p>
            <Button className = "btn btn-castleRed" onClick={handleButtonClick}>
             CHECK IT OUT
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

AhaWidget.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default AhaWidget;